import { render, staticRenderFns } from "./ConstructionPageView.vue?vue&type=template&id=8ca80418"
import script from "./ConstructionPageView.vue?vue&type=script&lang=js"
export * from "./ConstructionPageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports